import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'

export const StCurrentUserCardContainer = styled(FlexColumn)`
  ${({ theme }) => `
      position: relative;
      width: 100%;
      color: ${theme.Colors.Neutrals.Darkest};
      background-color: ${theme.Components.Card.Fill};

      display: flex;
      flex-direction: column;
      gap: ${theme.UI.SpacingPx.Space3};

      border-width: 1px;
      border-style: solid;
      border-radius: ${theme.UI.BorderRadius.Large}px;
      border-color: ${theme.Components.Card.Border};
      padding: ${theme.UI.SpacingPx.Space4};
      overflow: hidden;`}
`

export const StLogoutButton = styled.button`
  background-color: transparent;
  cursor: pointer;
`

export const StSwapPersonButton = styled.button`
  background-color: transparent;
  cursor: pointer;
`
